import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import { SnapshotService } from '../Services/snapshot.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-output-popup',
  templateUrl: './output-popup.component.html',
  styleUrls: ['./output-popup.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutputPopupComponent {
  @Output() dataEvent = new EventEmitter<boolean>();
  @Output() dataEventTrend = new EventEmitter<boolean>();
  @Output() dataEventCustom = new EventEmitter<boolean>();
  @Input() popUpParameter = '';
  @Input() visualization = '';
  @Input() id: number | undefined;
  @Input() item: any;
  @Input() data: any;
  @Input() customData: any;
  @Input() snapProduct: string = '';
  @Input() multiFunnelPopup: boolean = false;
  @Input() brandList: any = []
  @Input() metricList: any = [];
  @Input() initialMetric: any = null;
  @Input() trendLineView: any;
  @Input() showSnapshotARK: any;
  isviewDropdownOpen: any = false;
  clickedResult = '';
  Top10Container: boolean = false;
  Top10Toggle: boolean = true;
  DataLabelOn: boolean = false;
  BMList: any = [];
  viewList: any = [];
  charttype: string = "";
  zAxisMetric: string = "";
  popUpHeader: string = "";
  viewListBrands: any[] = [
    {
      option: "All Brands for Selected Metric",
      selected: true,
    }, {
      option: "All Metrics for Selected Brand",
      selected: false,
    },
  ]
  viewListMarkets: any = [
    {
      option: "All Markets for Selected Metric",
      selected: true,
    }, {
      option: "All Metrics for Selected Market",
      selected: false,
    },
  ]
  viewListAudiences: any[] = [
    {
      option: "All Audiences for Selected Metric",
      selected: true,
    }, {
      option: "All Metrics for Selected Audience",
      selected: false,
    },
  ]

  constructor(private _cdref: ChangeDetectorRef, private _configCustomService: CustomsnapshotService, public _configService: SnapshotService) {
    this.viewList = this.viewListBrands;

  }

  // True when the current snapshot is a Multi-Cohort (audience) snapshot.
  get isAudienceCohort(): boolean {
    const opt = (this._configService.selectedcompareacrossOption || '').replace(/\s+/g, '').toLowerCase();
    if (opt === 'multiplebrands' || opt === 'multiplemarkets') { return false; }
    return opt === 'audiencesnapshot'
      || !!this._configService.selectedSnapshotType?.toLowerCase().includes('audience');
  }

  gridData: any = [];
  toogleBrandMetricDropdownOpen: any = false;
  searchText: string = '';
  getAudienceDisplayLabel(colChild: string, allColChilds: string[]): string {
    if (!colChild || !colChild.includes('|')) { return colChild; }
    const parts = colChild.split('|');
    const last = parts[parts.length - 1];
    const dupCount = (allColChilds || []).filter((c: string) => {
      if (!c || !c.includes('|')) { return c === last; }
      const p = c.split('|');
      return p[p.length - 1] === last;
    }).length;
    if (dupCount > 1 && parts.length >= 2) {
      return parts[parts.length - 2] + ' | ' + last;
    }
    return last;
  }
  // Display label for an item shown in the adjacent (brand/metric/audience) dropdown.
  // For Multi-Cohort audience entries (colChild like "Audience|Race|Hispanic") the
  // unmatched-portion logic is applied so only the distinguishing part is shown.
  getBMItemLabel(option: string): string {
    if (!option) { return option; }
    if (this.isAudienceCohort && option.includes('|')) {
      const allOptions = (this.BMList || []).map((b: any) => b.option);
      return this.getAudienceDisplayLabel(option, allOptions);
    }
    if (option.includes('|')) {
      const head = option.split('|')[0].toLowerCase();
      if (head === 'brands' || head === 'metric' || head === 'audience'|| head === 'market') {
        return option.split('|')[1];
      }
    }
    return option;
  }
  // Label shown on the adjacent dropdown toggle button.
  getSelectedBMDisplay(): string {
    if (this.metricSelected !== '' && this.metricSelected != null) {
      return this.metricSelected;
    }
    if (this.brandSelected !== '' && this.brandSelected != null) {
      if (this.isAudienceCohort && this.brandSelected.includes('|')) {
        const allOptions = (this.brandList || []).map((b: any) => b.option);
        return this.getAudienceDisplayLabel(this.brandSelected, allOptions);
      }
      return this.brandSelected.includes('|') ? this.brandSelected.split('|')[1] : this.brandSelected;
    }
    return 'Select';
  }
  toogleViewDropdown() {
    this.isviewDropdownOpen = !this.isviewDropdownOpen;
    event?.stopPropagation();
  }
  closeViewDropdown() {
    this.isviewDropdownOpen = false;
  }
  toogleBrandMetricDropdown() {
    this.toogleBrandMetricDropdownOpen = !this.toogleBrandMetricDropdownOpen
    event?.stopPropagation();
  }


  isTrendView: boolean = true;
  isSampleSize: boolean = false;
  toggleTrendSample(view: any) {
    if (view == 'trendview') {
      this.isTrendView = true;
      this.isSampleSize = false;
    }
    else {
      this.prepareSampleSize();

    }
  }

  closeBrandMetricDropdown() {
    this.toogleBrandMetricDropdownOpen = false;
    this.searchText = '';
  }
  getFilteredBMList() {
    if (!this.searchText) {
      return this.BMList;
    }
    return this.BMList.filter((item: any) =>
      item.option.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  onSearchInput(event: any) {
    this.searchText = event.target.value;
  }
  ngOnInit() {

    if (this.snapProduct == "custom") {
      const FoundItem = this.customData.metric.find((item: any) => item.metric_option === "ZAxis Metric : ");
      if (FoundItem)
        this.zAxisMetric = FoundItem.metric_value[0].option;
      //  this.zAxisMetric = this.customData.metric.find((item:any) => item.metric_option === "ZAxis Metric : "
      //                                                           ).metric_value[0].option;
      this.charttype = this.customData.widgetchart_name;
      if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
        this.viewList = _.cloneDeep(this.viewListBrands);
        this.viewselected = this.viewList[0].option;
      }
      if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
        this.viewList = _.cloneDeep(this.viewListMarkets);

        this.viewselected = this.viewList[0].option;
      }
      // Multi-Cohort (audience) snapshot: use Audience based view options.
      if (this.isAudienceCohort) {
        this.viewList = _.cloneDeep(this.viewListAudiences);
        this.viewselected = this.viewList[0].option;
      }
      if (this.multiFunnelPopup) {
        const isAudienceSnapshot = this._configService.selectedSnapshotType.toLowerCase().includes('audience') && this._configService.multiCohort;
        const allColChilds = this.customData.metric[0].metric_value[0].data.map((d: any) => d.colChild);
        this.customData.metric[0].metric_value[0].data.forEach((d: any) => {
          // For audience snapshot, extract the audience name from colChild (e.g., "Audience|Gender|Male" -> "Male")
          // When multiple audiences share the same last-level option, concatenate the last 2 levels
          let headerValue = d.colChild;
          if (isAudienceSnapshot && d.colChild && d.colChild.includes('|')) {
            headerValue = this.getAudienceDisplayLabel(d.colChild, allColChilds);
          }
          this.gridData.push({
            header: headerValue,
            data: this.customData
          })
        })
      }
      if (this.metricList.length > 0) {
        const preselected = this.initialMetric && this.metricList.find((m: any) => m === this.initialMetric);
        const resolvedMetric = preselected || this.metricList[0];
        // Only the trendline-2 "View" mode (Brand/Metric dropdown) restricts the expanded
        // chart to a single selected metric. For any other trend view the chart must render
        // every metric as its own series, matching the Sample Size table, so metricSelected
        // is left empty. Non-Line-Chart popups keep the original single-metric behaviour.
        const restrictToSingleMetric = this.visualization !== 'Line Chart' || this.trendLineView == 2;
        this.metricSelected = restrictToSingleMetric ? resolvedMetric : "";
        this.metricList = this.metricList.map((m: any) => {
          return {
            option: m,
            selected: m === resolvedMetric
          }
        })

      }
      if (this.brandList.length > 0) {
        this.brandSelected = "";
        this.brandList = this.brandList.map((m: any, index: any) => {
          return {
            option: m,
            selected: index === 0
          }
        })

      }
      this.BMList = this.metricList;

      // Used by expand + trend popups. Match option/metricName; never wipe all series on mismatch
      // (that caused Line Chart "Trendline data not available" while sample size still existed).
      if (this.customData && this.metricList.length > 0 && Array.isArray(this.customData.metric?.[0]?.metric_value)) {
        const filtered = this.customData.metric[0].metric_value.filter((m: any) =>
          this.metricList.some((metric: any) => {
            const listOpt = (metric?.option ?? '').toString().trim();
            const mvOpt = (m?.option ?? '').toString().trim();
            const mvName = (m?.metricName ?? '').toString().trim();
            return listOpt !== '' && (listOpt === mvOpt || listOpt === mvName);
          })
        );
        if (filtered.length > 0) {
          this.customData.metric[0].metric_value = filtered;
        }
        // For Line Chart only: if nothing matched, keep original series (avoids empty trend popup).
        // Other visualizations keep previous behavior when filter matches; empty filter left unchanged
        // so intentional empty metricList subsets are not forced.
      }
    }
    else {
      if (
        this.data[0].metricSelected.metrics.length > 10 &&
        this.visualization === 'Line Chart'
      ) {
        this.Top10Container = true;
      }
      if (this.visualization == 'Funnel Chart') {
        this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
      if (this.Top10Container == true) {
        this.Top10Toggle = true;
      }
    }

    if (this._configService.weights && this._configService.weights.length > 0) {
      this.weightSelectedValue = this._configService.weights[0]?.key;
    }

    this.popUpHeader = this.popUpParameter;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.visualization == 'Funnel Chart') {
      this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
    }
  }
  viewselected: any = "All Brands for Selected Metric";
  viewSelected(item: any) {
    
this.viewList.forEach((v: any) => {
    v.selected = false;
  });

  item.selected = true;
  this.viewselected = item.option;

    this.viewList.forEach((v: any) => {
      if (item.option == v.option) {
        
        this.viewselected = v.option;
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
          if (v.option == "All Brands for Selected Metric") {
            this.brandSelected = "";
            this.metricList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.BMList = this.metricList;
            this.metricSelected = this.metricList[0].option;
          }
          else {
            this.metricSelected = "";
            this.brandList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.brandSelected = this.brandList[0].option;
            this.BMList = this.brandList;
          }
        }
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
          if (v.option == "All Markets for Selected Metric") {
            this.brandSelected = "";
            this.metricList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.BMList = this.metricList;
          }
          else {
            this.metricSelected = "";
            this.brandList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.brandSelected = this.brandList[0].option;
            this.BMList = this.brandList;
          }
        }
        // Multi-Cohort (audience): mirror the Multi-Brand behaviour with Audience.
        if (this.isAudienceCohort) {
          if (v.option == "All Audiences for Selected Metric") {
            this.brandSelected = "";
            this.metricList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.BMList = this.metricList;
            this.metricSelected = this.metricList[0]?.option;
          }
          else {
            this.metricSelected = "";
            this.brandList.forEach((m: any, index: any) => {
              m.selected = index === 0;
            })
            this.brandSelected = this.brandList[0]?.option;
            this.BMList = this.brandList;
          }
        }

        if (this.customData.metricdropdownOutput == 1) {
          if (this.viewselected == "All Brands for Selected Metric" || this.viewselected == "All Audiences for Selected Metric") {
            this.popUpHeader = this.customData.widget_name + " - " + this.metricSelected;
          } else {
            this.popUpHeader = this.customData.widget_name;
          }
        }
      }
      else {
        v.selected = false;
      }
      this._cdref.detectChanges();
    })
  }
  metricSelected: any = "";
  brandSelected: any = "";
  brandMetricSelected(item: any, itemindex: any) {
    if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
      if (this.viewselected == "All Brands for Selected Metric") {
        this.metricList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.metricSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
      else {
        this.brandList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.brandSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
    }
    if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
      if (this.viewselected == "All Markets for Selected Metric") {
        this.metricList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.metricSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
      else {
        this.brandList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.brandSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
    }
    // Multi-Cohort (audience): mirror the Multi-Brand behaviour with Audience.
    if (this.isAudienceCohort) {
      if (this.viewselected == "All Audiences for Selected Metric") {
        this.metricList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.metricSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
      else {
        this.brandList.forEach((v: any, index: any) => {
          if (item.option == v.option && index == itemindex) {
            v.selected = true;
            this.brandSelected = v.option;
          }
          else {
            v.selected = false;
          }
        })
      }
    }

    if (this.customData.metricdropdownOutput == 1) {
      if (this.viewselected == "All Brands for Selected Metric" || this.viewselected == "All Audiences for Selected Metric") {
        this.popUpHeader = this.customData.widget_name + " - " + this.metricSelected;
      } else {
        this.popUpHeader = this.customData.widget_name;
      }
    }
  }

  Top10selected() {
    this.Top10Toggle = true;
  }

  Allselected() {
    this.Top10Toggle = false;
  }

  DataLabelOnClick() {
    this.DataLabelOn = true;
  }

  DataLabelOffClick() {
    this.DataLabelOn = false;
  }

  collapseExandPopup() {
    this.dataEvent.emit(false);
    this.dataEventCustom.emit(false);

    this.dataEventTrend.emit(false);
  }


  opobject: any = {
    Column: [], Row: []
  }
  TrendToggleContainer: boolean = false;
  TrendToggleOn: boolean = false;
  weightSelectedValue: any = "";
  sampleSizeOutputData: any = [];
  OutputdataObject: any = {
    Column: [], Row: []
  }
  prepareSampleSize() {
    this.opobject = {
      Column: [], Row: []
    }


    this.TrendToggleContainer = true;
    this.TrendToggleOn = true;
    let data = [this.customData]

    const widgetDetailsInParticularPage = data.map((item: any) => item.widget_name);
    let uniqueObjects = [
      ...new Map(
        this._configService.trendOutputDbCallData
          .filter((i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1)
          .map((item: any) => [item.widgetName, item])
      ).values()
    ];

    let pagedetails = _.cloneDeep(
      this._configService.trendOutputDbCallData.filter((i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1)
    );

    uniqueObjects.forEach((i: any) => {
      let nestedArray1 = pagedetails
        .filter(
          (p: any) =>
            p.widgetName == i.widgetName
        )
        .map((p: any) => {
          return {
            CalculationType: p.CalculationType,
            Child: p.rowChild,
            Level1ColChild: p.Level1ColChild,
            NestedArray: [],
            customCalculationId: p.customCalculationId || null,
            customGroupId: p.customGroupId || null,
            isCustomCalculation: p.isCustomCalculation || false,
            isCustomGroup: p.isCustomGroup || false,
            isDerived: p.isDerived || false,
            responsecode:  p.rowResponseCode?.toString() ?? null,
            variablecode: p.rowVariableCode,
            unweightedBase:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalUnweightedBase
                : p.answerUnweightedBase,
            weightedBase:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalWeightedBase
                : p.answerWeightedBase,
            WeightedNumerator:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.totalWeightedNumerator
                : p.answerWeightedNumerator,
            UnweightedNumerator:
              this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                ? p.CurrentNumeratorUnWeighted_Total
                : p.CurrentNumeratorUnWeighted_Answer,
            trend: true,
            brand: p.colChild ? (p.colChild.includes('|') ? p.colChild.split('|').slice(1).join('|') : p.colChild) : (p.rowChild || ''),
            ChildName: p.rowChild.includes("|") ? p.rowChild.split("|")[1].trim() : p.rowChild
          };
        });


      this.opobject.Row.push({
        Data: [{
          CalculationType: i.CalculationType || "share",
           Child: widgetDetailsInParticularPage[i.widgetName] ?  i.widgetName + '_' + widgetDetailsInParticularPage[i.widgetName].trim() : i.widgetName,
          Level1ColChild: i.Level1ColChild,
          NestedArray: nestedArray1,
          customCalculationId: i.customCalculationId || null,
          customGroupId: i.customGroupId || null,
          isCustomCalculation: i.isCustomCalculation || false,
          isCustomGroup: i.isCustomGroup || false,
          isDerived: i.isDerived || false,
          responsecode: "1",
          variablecode: "MO_MOb_2b_DAYPART",
          ChildName: i?.Level1ColChild?.includes("|") ? i?.Level1ColChild?.split("|")[1].trim() : i?.Level1ColChild?.trim()
        }
        ],
        Data1: [{ NestedArray: [] }],
        Parent: i.colChild
          ? (i.colChild.includes('|') ? i.colChild.split('|')[1] : i.colChild)
          : (i.rowChild || ''),
        customCalculationId: i.customCalculationId || null,
        customGroupId: i.customGroupId || null,
        isCustomCalculation: i.isCustomCalculation || false,
        isCustomGroup: i.isCustomGroup || false
      })
    })

    let uniqueColObjects = Object.values(this._configService.trendOutputDbCallData.reduce((acc: any, obj: any) => {
      acc[obj.Level1ColChild] = obj;
      return acc;
    }, {}));

    // Skip sorting on UI side. The response from the backend is sorted according to the time period sort id from tpm file.
    /*
    uniqueColObjects.sort((a: any, b: any) => {
      const aCode = this.parseResponseCode(a.Level1ColResponseCode);
      const bCode = this.parseResponseCode(b.Level1ColResponseCode);

      // Compare year first, then number if years are equal
      if (!Number.isNaN(aCode.year) && !Number.isNaN(bCode.year)) {
        if (aCode.year !== bCode.year) {
          return aCode.year - bCode.year;
        }
      }
      return aCode.num - bCode.num;
    });

    uniqueColObjects.sort((a: any, b: any) => {
      let firstData = a.Level1ColChild;
      let secondData = b.Level1ColChild;
      if (firstData.includes("|")) {
        firstData = firstData.split("|")[1]
        secondData = secondData.split("|")[1];

        if (firstData.includes("_")) {
          firstData = firstData.split("_")[1];
          secondData = secondData.split("_")[1];
        }

        firstData = parseInt(firstData);
        secondData = parseInt(secondData);
      } else {
        firstData = parseInt(firstData);
        secondData = parseInt(secondData);

      }
      return firstData - secondData;
    })

    uniqueColObjects.sort((a: any, b: any) => {
      const [monthA, yearA] = a.Level1ColChild?.split("|")[1].split("_");
      const [monthB, yearB] = b.Level1ColChild?.split("|")[1].split("_");

      const dateA: any = new Date(yearA, this.getMonthNumber(monthA) - 1);
      const dateB: any = new Date(yearB, this.getMonthNumber(monthB) - 1);

      return dateA - dateB;
    });
    */

    uniqueColObjects.forEach((i: any) => {
      let col = {
        Data: [{
          CalculationType: i.CalculationType,
          Child: i.Level1ColChild,
          NestedArray: [],
          customCalculationId: null,
          customGroupId: null,
          isCustomCalculation: false,
          isCustomGroup: false,
          isDerived: false,
          responsecode: i.Level1ColResponseCode,
          variablecode: i.Level1NestColVariableCode,
          ChildName: i.Level1ColChild.includes("|") ? i.Level1ColChild.split("|")[1].trim() : i.Level1ColChild
        }],
        Parent: "Month",
        customCalculationId: null,
        isCustomCalculation: false,
        isCustomGroup: false
      }
      if (!this.opobject.Column.includes(col)) {
        this.opobject.Column.push(col);
      }
    })


    //     Level1ColChild
    // : 
    // "Month|May_2023"
    // Level1ColResponseCode
    // : 
    // "5 2023"
    // Level1NestColVariableCode
    // : 
    // "Month_code"

    this.sampleSizeOutputData = JSON.parse(JSON.stringify(this._configService.trendOutputDbCallData));
    this.sampleSizeOutputData = this.sampleSizeOutputData.filter((m: any) => widgetDetailsInParticularPage.indexOf(m.widgetName) > -1)

    this.OutputdataObject = this.opobject;
    this.isSampleSize = true;



    this.isTrendView = false;
    this.isSampleSize = true;

  }

  getMonthNumber(monthAbbr: any): number {
    const months = [
      ["jan", "january"],
      ["feb", "february"],
      ["mar", "march"],
      ["apr", "april"],
      ["may", "may"],
      ["jun", "june"],
      ["jul", "july"],
      ["aug", "august"],
      ["sep", "september"],
      ["oct", "october"],
      ["nov", "november"],
      ["dec", "december"],
    ];

  const normalized = monthAbbr?.toLowerCase().trim();
  const index = months.findIndex((aliases) => aliases.includes(normalized));
  return index + 1; // returns 0 if not found
}

  parseResponseCode(code: any) {
    const [num, year] = code.split(' ');
    return { num: parseInt(num, 10), year: parseInt(year, 10) };
  };
}
